import { render, staticRenderFns } from "./MineTypeSelector.vue?vue&type=template&id=96cb6074"
import script from "./MineTypeSelector.vue?vue&type=script&lang=js"
export * from "./MineTypeSelector.vue?vue&type=script&lang=js"
import style0 from "./MineTypeSelector.vue?vue&type=style&index=0&id=96cb6074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports